/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ClydeIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB9ElEQVR4nO1UvWsUURB/QUMEsTNiCgUVsbIzjWhOhIMj2fnYwLuZy4ex8arEFIEQW5PKJvZa2KhJLYiFCJrOMklj6V9gjBEimDuZO4+73bzdmHhlBgaW/f3eb+bNx3Pu2I5qpVKpL+LKLSCdq1arvWnc/gHpPJHcLkxNnfpn4SguDyLrc2DdRtZ602UZWWaR9XHTZRZIn7Zw4wLLM0S9kSuO6K8h625bWA/lQPqLWa5kBgDWD0cVx5aTrIbFY7373+Lc8BqR3NxfHtI3XQpQB9aXCfE4Hh8A0t/dCoCsPxHxTDt71gfhTGQdSF8D6VagoVsNjGU93HC531EeeREgvS8UCicNJxq7bhPSOS32zzDjGDe3TEj6OU2ISCaTPZK1jklZS+wOyWTghl9aeA+Q/ggQZhIBWDbbAXQjgcX6MLQT3vsTbtj78xmN+joyWrnaSIBlOtCfacOMY9yQRhxPnHMA/lLeTCPL98xxbDa/loVHkb/oiORCF8eznrzB+IArFidOA8u31IjtAckisH6y7+wbyB6wfgTSpTTPNE27vWisK0kB2bE6l7zvj6jCwPoISJ+YI8sCsFAUVc42Gyw7ibMkr6y3ofeoCCzv/mZTQywPuQOMSO4Yt3GG9K29aQedcSOjY5fTe5BniOV7Niy5pGNzGfYH0TJFmt8sPBMAAAAASUVORK5CYII=)
 */
export const ClydeIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19.73 4.87a18.2 18.2 0 0 0-4.6-1.44c-.21.4-.4.8-.58 1.21-1.69-.25-3.4-.25-5.1 0-.18-.41-.37-.82-.59-1.2-1.6.27-3.14.75-4.6 1.43A19.04 19.04 0 0 0 .96 17.7a18.43 18.43 0 0 0 5.63 2.87c.46-.62.86-1.28 1.2-1.98-.65-.25-1.29-.55-1.9-.92.17-.12.32-.24.47-.37 3.58 1.7 7.7 1.7 11.28 0l.46.37c-.6.36-1.25.67-1.9.92.35.7.75 1.35 1.2 1.98 2.03-.63 3.94-1.6 5.64-2.87.47-4.87-.78-9.09-3.3-12.83ZM8.3 15.12c-1.1 0-2-1.02-2-2.27 0-1.24.88-2.26 2-2.26s2.02 1.02 2 2.26c0 1.25-.89 2.27-2 2.27Zm7.4 0c-1.1 0-2-1.02-2-2.27 0-1.24.88-2.26 2-2.26s2.02 1.02 2 2.26c0 1.25-.88 2.27-2 2.27Z"
        className={colorClass}
      />
    </svg>
  );
};
